import mixpanel, { Mixpanel } from 'mixpanel-browser';

let cosmosMixpanelInstance: Mixpanel;
let surveyPortalMixpanelInstance: Mixpanel;
if (['local', 'development', 'staging'].includes(process.env.REACT_APP_ENV || '')) {
  console.log('Initializing Mixpanel for staging');
  cosmosMixpanelInstance = mixpanel.init(
    process.env.REACT_APP_MIXPANEL_TOKEN || '',
    { debug: true },
    'cosmos',
  );
  surveyPortalMixpanelInstance = mixpanel.init(
    process.env.REACT_APP_SURVEY_REFRESH_MIXPANEL_TOKEN || '',
    { debug: true },
    'survey_portal',
  );
} else if (['production'].includes(process.env.REACT_APP_ENV || '')) {
  cosmosMixpanelInstance = mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '', {}, 'cosmos');
  surveyPortalMixpanelInstance = mixpanel.init(
    process.env.REACT_APP_SURVEY_REFRESH_MIXPANEL_TOKEN || '',
    {},
    'survey_portal',
  );
} else {
  console.log(`Purposely Registering Invalid MixPanel Token For Env: ${process.env.REACT_APP_ENV}`);
  cosmosMixpanelInstance = mixpanel.init('INVALID', { debug: true })!;
  surveyPortalMixpanelInstance = mixpanel.init('INVALID', { debug: true })!;
}

export const cosmosMixpanel = cosmosMixpanelInstance;
export const surveyPortalMixpanel = surveyPortalMixpanelInstance;
